export default {
  admin_area_vect_layer: "行政區域向量圖層",
  alarm_end_time: "報警結束時間",
  alarm_information_query_alm_info_qry: "告警資訊查詢",
  alarm_start_time: "報警開始時間",
  area: "報警區域",
  dev_alarm_source: "設備報警源",
  dev_info_mgmt: "設備資訊管理",
  dl_template: "下載範本",
  dm: "設備管理",
  enable: "啟用",
  filter_false_alarm: "誤報過濾",
  handle_and_push: "處置並推送",
  have: "有",
  lat: "緯度",
  linked_devs: "聯動設備",
  loc: "位置",
  lon: "經度",
  lon_lat: "經緯度",
  menu: "菜單",
  nav_to_this_loc: "導航到這",
  playback_history: "回放歷史",
  res: "資源",
  resp_person: "責任人",
  res_info_mgmt: "資源資訊管理",
  res_name: "資源名稱",
  res_type: "資源類型",
  rm: "資源管理",
  show_video: "展示視頻",
  tgt_az_angle: "目標方位角度",
  tgt_el_angle: "目標俯仰角度",
  tgt_loc: "目標位置",
  tgt_lon_lat: "目標經緯度",
  tgt_point: "目標點",
  tgt_type: "目標類型",
  times: "次",
  tracking: "切換追蹤",
  ves_dest: "船隻目的地",
  ves_lon_lat: "船隻經緯度",
  ves_name: "船隻名稱",
  ves_type: "船隻類型",
  video_surveillance_alarmvid_sur_alm: "視頻監控報警",
};
